<script setup lang="ts">
import ReviewManagement from "@/views/playground/planner/business-management/review-management/ReviewManagement.vue";
</script>

<template>
  <review-management></review-management>
</template>

<style scoped></style>
